import React, { useRef, createElement } from 'react';
import { motion, useInView } from 'framer-motion';
const media = [{
  name: 'Inc42',
  url: 'https://inc42.com/buzz/the-yarn-bazaar-bags-funding-to-offer-flexible-financing-options-to-sellers/',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Inc42_logo.svg/320px-Inc42_logo.svg.png'
}, {
  name: 'Zee Business',
  url: 'https://www.zeebiz.com/hindi/small-business/the-yarn-bazaar-raises-rs-15-cr-in-pre-series-a-round-who-got-four-shark-deal-in-shark-tank-india-132761',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Zee_Business_logo.svg/320px-Zee_Business_logo.svg.png'
}, {
  name: 'CNBC',
  url: 'https://www.youtube.com/watch?v=-xgYfAAq49k',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/CNBC_logo.svg/320px-CNBC_logo.svg.png'
}, {
  name: 'The Hindu',
  url: 'https://www.thehindu.com/business/Industry/yarn-bazaar-raises-funds/article66988897.ece',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/The_Hindu_logo.svg/320px-The_Hindu_logo.svg.png'
}, {
  name: 'Money Control',
  url: 'https://www.moneycontrol.com/news/trends/lifestyle/book-excerpt-what-are-shark-tank-india-judges-looking-for-in-a-startup-10298991.html',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Moneycontrol_logo.svg/320px-Moneycontrol_logo.svg.png'
}, {
  name: 'Economic Times',
  url: 'https://economictimes.indiatimes.com/',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/The_Economic_Times_logo.svg/320px-The_Economic_Times_logo.svg.png'
}, {
  name: 'Business Line',
  url: 'https://www.thehindubusinessline.com/economy/agri-business/online-platform-the-yarn-bazaar-plans-to-take-up-financing-expand-footprint-abroad/article66842574.ece',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/The_Hindu_logo.svg/320px-The_Hindu_logo.svg.png'
}];
export function TrustBar() {
  const doubled = [...media, ...media, ...media];
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.section ref={ref} initial={{
    opacity: 0
  }} animate={isInView ? {
    opacity: 1
  } : {}} transition={{
    duration: 0.8
  }} className="py-12 bg-white border-y border-[#E8E4DC] overflow-hidden relative" data-id="element-605">
      {/* Animated top border line */}
      <motion.div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E8500A]/30 to-transparent" initial={{
      scaleX: 0
    }} animate={isInView ? {
      scaleX: 1
    } : {}} transition={{
      duration: 1.2,
      ease: 'easeInOut'
    }} data-id="element-606" />

      <div className="max-w-6xl mx-auto px-5 mb-7" data-id="element-607">
        <p className="text-center text-[11px] text-[#9B9890] font-inter tracking-[0.18em] uppercase font-medium" data-id="element-608">
          Featured In
        </p>
      </div>

      <div className="relative overflow-hidden" data-id="element-609">
        <div className="flex gap-12 marquee-track whitespace-nowrap items-center" data-id="element-610">
          {doubled.map((item, i) => <a key={i} href={item.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center flex-shrink-0 opacity-40 hover:opacity-80 transition-opacity duration-300 cursor-pointer" title={item.name} data-id="element-611">
              <img src={item.logo} alt={item.name} className="h-5 w-auto object-contain grayscale" onError={e => {
            const target = e.currentTarget as HTMLImageElement;
            target.style.display = 'none';
            const span = document.createElement('span');
            span.className = 'text-sm font-inter font-semibold text-[#C8C4BC] tracking-wide';
            span.textContent = item.name;
            target.parentNode?.appendChild(span);
          }} data-id="element-612" />
            </a>)}
        </div>
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent pointer-events-none z-10" data-id="element-613" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent pointer-events-none z-10" data-id="element-614" />
      </div>

      {/* Shark Tank badge */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-6xl mx-auto px-5 mt-8" data-id="element-615">
        <a href="https://www.youtube.com/watch?v=yi8xTTuB4V0" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-4 py-3.5 px-6 rounded-2xl bg-[#FAFAF8] border border-[#E8E4DC] max-w-sm mx-auto hover:border-[#D4CFC5] transition-colors group card-lift" data-id="element-616">
          <div className="w-9 h-9 rounded-xl bg-red-600 flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform" data-id="element-617">
            <svg className="w-4 h-4 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24" data-id="element-618">
              <path d="M8 5v14l11-7z" data-id="element-619" />
            </svg>
          </div>
          <div data-id="element-620">
            <p className="text-sm font-jakarta font-bold text-[#0F0E0C]" data-id="element-621">
              Shark Tank India · Season 1
            </p>
            <p className="text-xs text-[#9B9890] font-inter" data-id="element-622">
              Funded · 1M+ views on pitch
            </p>
          </div>
          <span className="ml-auto text-xs font-inter font-semibold text-[#E8500A] hover:text-[#D14508] transition-colors flex items-center gap-1" data-id="element-623">
            Watch
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-624">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-625" />
            </svg>
          </span>
        </a>
      </motion.div>
    </motion.section>;
}